import { render, staticRenderFns } from "./index.vue?vue&type=template&id=55fa4d9a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=55fa4d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fa4d9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55fa4d9a')) {
      api.createRecord('55fa4d9a', component.options)
    } else {
      api.reload('55fa4d9a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=55fa4d9a&scoped=true&", function () {
      api.rerender('55fa4d9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploadByOss/index.vue"
export default component.exports